var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgReport = function SvgReport(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-24": 18,
    viewBox: "0 0 17.6 17.6",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.92 0a2.74 2.74 0 0 1 2 .81l3.82 3.82a2.74 2.74 0 0 1 .81 2v8.62a2.25 2.25 0 0 1-2.3 2.25h-13A2.25 2.25 0 0 1 0 15.25v-13A2.25 2.25 0 0 1 2.25 0zM2.25 1.5a.76.76 0 0 0-.75.75v13a.76.76 0 0 0 .75.75h13a.76.76 0 0 0 .75-.75V6.58a1.24 1.24 0 0 0-.37-.89l-3.82-3.82a1.26 1.26 0 0 0-.89-.37z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.75 12.75v-2m3 2v-4m3 4v-6"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReport);
export default ForwardRef;